import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'reyher',
} as IModuleProps;
